import './Card.css';
import StatusBadge from './StatusBadge';

const SuccessRateCard = ({ data, loading, error }) => {
  if (loading) return (
    <div className="empty-card">
      <div className="metric-header">
        <h2>Daily success rate</h2>
        <StatusBadge status="loading" label="Loading" />
      </div>
      <div className="metric-value loading flashing" style={{ height: '80%' }}></div>
    </div>
  );

  if (error) return (
    <div className="empty-card">
      <div className="metric-header">
        <h2>Daily success rate</h2>
        <StatusBadge status="error" label="Error" />
      </div>
      <div className="metric-value error flashing" style={{ height: '80%' }}></div>
    </div>
  );

  if (!data) return (
    <div className="empty-card">
      <div className="metric-header">
        <h2>Daily success rate</h2>
        <StatusBadge status="no-data" label="No data" className="flashing" />
      </div>
      <div className="metric-value no-data flashing" style={{ height: '80%' }}></div>
    </div>
  );

  if (data) {
    const totalTests = data.passed + data.failed;
    const daySuccessRate = totalTests > 0 ? (data.passed / totalTests) * 100 : null;
    const baseSuccessRate = data.lastWeekSuccessRate;
    const hasComparison = daySuccessRate !== null && baseSuccessRate !== null;
    const deltaPassRate = hasComparison ? daySuccessRate - baseSuccessRate : null;
    const improved = deltaPassRate !== null && deltaPassRate >= 0;
    return (
      <div className="empty-card">
        <div className="metric-header">
          <h2>Daily success rate</h2>
          {hasComparison && (
            <StatusBadge status={improved ? "improved" : "degraded"} label={improved ? "Improved" : "Degraded"} />
          )}
        </div>
        <div className="metric-value">{daySuccessRate !== null ? `${daySuccessRate.toFixed(2)} %` : 'N/A'}</div>
        <div className="metric-comparison">
          {hasComparison ? (
            <>
              <span className={ improved ? "percentage-decrease" : "percentage-increase" }>{ improved ? "+" : "-" }</span>
              <span className={ improved ? "percentage-decrease" : "percentage-increase" }>{ Math.abs(deltaPassRate).toFixed(2) }%</span>
              <span className="comparison-period">vs. previous period</span>
            </>
          ) : (
            <span className="comparison-period">No previous period data</span>
          )}
        </div>
        <p className="metric-description">
          The test success rate compared to the equivalent previous period.
        </p>
      </div>
      );
  }
};

export default SuccessRateCard; 